import { render, staticRenderFns } from "./botany_info.vue?vue&type=template&id=41e2d4aa&"
import script from "./botany_info.vue?vue&type=script&lang=js&"
export * from "./botany_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports